import {PROPERTY_SELECTOR_SIGIL} from '../constants';

// TODO: this should be refactored to remove some redundancy with creatGetAffected
export default mappings =>
	function getComponentAffected(propertyName, providerId) {
		let componentsAffected = {
			...mappings[`${providerId}${PROPERTY_SELECTOR_SIGIL}${propertyName}`]
		};

		if (!Object.keys(componentsAffected).length) return componentsAffected;

		(function getAffectedSelectorChain(componentMap) {
			for (const selectorMap in componentMap) {
				if (mappings[selectorMap]) {
					componentsAffected = {
						...componentsAffected,
						...mappings[selectorMap]
					};
					getAffectedSelectorChain(mappings[selectorMap]);
				}
			}
		})(componentsAffected);

		return componentsAffected;
	};
